import liCSS from 'components/MakeModelMenu/liCSS';
import { colors } from 'components/styles/variables';
import searchIcon from 'public/static/images/paid_landing/search-icon.svg';
import { ChooseFunction } from './types';

interface FilterComponentProps {
  handleFilter: (filter: string) => void;
  makeOrModel?: string;
}

interface AllComponentProps {
  choose?: ChooseFunction;
  text?: string;
}

interface TopComponentProps {
  handleFilter: (filter: string) => void;
  includeAll?: boolean;
  chooseAll?: ChooseFunction;
  allText?: string;
  makeOrModel?: string;
}

const Filter = ({ handleFilter, makeOrModel }: FilterComponentProps): JSX.Element => (
  <div className="filter-container">
    <div className="input-container">
      <div className="search-icon" />
      <input
        data-testid="make-model-menu-filter-input"
        type="text"
        placeholder={`Search for a ${makeOrModel}`}
        onChange={(event): void => {
          const { value } = event.target;

          if (!value) {
            return;
          }

          handleFilter(value);
        }}
      />
    </div>
    <style jsx>{liCSS}</style>

    <style jsx>{`
      .filter-container {
        position: sticky;
        top: 0;
        background-color: white;
        z-index: 1;
      }

      .input-container {
        position: relative;
        padding: 12px 16px;
        box-shadow: 0 1px 0 0 ${colors.G2};
      }

      .search-icon {
        position: absolute;
        z-index: 1;
        height: 22px;
        width: 22px;
        top: 25px;
        left: 28px;
        background-image: url('${searchIcon}');
        background-size: cover;
      }

      input {
        background-color: white;
        border: 1px solid ${colors.BLACK};
        height: 48px;
        width: 100%;
        font-size: 18px;
        color: ${colors.BLACK};
        padding: 5px 5px 5px 42px;
        -webkit-appearance: none;
        border-radius: 8px;
        outline: none;
      }

      input ::placeholder {
        color: ${colors.G4};
        font-weight: 100;
      }

      input:not(:focus) {
        background-color: ${colors.G1};
        border: 1px solid ${colors.G2};
      }
    `}</style>
  </div>
);

const All = ({ choose, text }: AllComponentProps): JSX.Element => (
  <li className="all-container" data-make-all onClick={choose}>
    <div>{text}</div>
    <style jsx>{liCSS}</style>
    <style jsx>{`
      .all-container {
        display: flex;
        align-items: center;
      }
    `}</style>
  </li>
);

const Top = ({
  handleFilter,
  includeAll,
  chooseAll,
  allText,
  makeOrModel,
}: TopComponentProps): JSX.Element => (
  <>
    <Filter handleFilter={handleFilter} makeOrModel={makeOrModel} />
    {includeAll ? <All choose={chooseAll} text={allText} /> : null}
  </>
);

export default Top;
